import { PureComponent } from 'react'

class XAxisTick extends PureComponent {
  render () {
    const { children, svgProps, textProps } = this.props
    const { x, y, ...restSVGProps } = svgProps

    return (
      <g
        transform={`translate(${x},${y})`}
        {...restSVGProps}
      >
        <text
          x={0}
          y={0}
          dy={16}
          textAnchor='middle'
          fill='#979ba7'
          fontSize='12'
          {...textProps}
        >
          {children}
        </text>
      </g>
    )
  }
}

export default XAxisTick
